'use client';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Flex from '@/components/Flex';

import { CustomButton, EButtonVariants } from '@/components/CustomButton';

import { useGoBack } from '@/hooks';
import { EButtonSizes } from '../CustomButton/CustomButton.types';
import styles from './BackHeading.module.scss';

export const BackHeading = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const { goBack } = useGoBack();

  return (
    <Flex gap="12px" alignItemsCenter className={className}>
      <CustomButton
        link
        title="Ir atrás"
        iconName={faArrowLeft}
        onClick={goBack}
        size={EButtonSizes.LG}
        variant={EButtonVariants.MINIMAL}
      />
      <h1 className={styles.heading}>{children}</h1>
    </Flex>
  );
};
